import {ENDPOINT_VERSIONS} from './_endpoint-versions';

export const AUDIT_LOGS_GET_ENDPOINT = `/${ENDPOINT_VERSIONS.V2}/audit-logs`;
